<template>
  <div class="video-preview-uniview">
    <div v-if="isInstallUniview" class="video-preview-uniview-warp">
      <div ref="univiewVideo" :id="`uniview${code}`" class="video-preview-uniview-video"></div>
    </div>
    <div class="uninstall" v-else>
      <div class="info">
        <p>您当前未安装播放器插件</p>
        <a @click="openLocalPlayer">尝试打开播放器</a><br/>
        <a @click="downloadLocalPlayer">点此安装</a>
      </div>
    </div>
  </div>
</template>

<script>
// import "./../assets/imosSdk.min.js";
import axios from "axios";
import { URLS, VIDEO_PREVIEW_KEYS } from '../config.js';
import { hex_md5 } from '../utils/md5.js';
import { loadScript } from '../utils/index.js';

export default {
  props: {
    code: String,
    config: Object,
    proxyHost: {
        type: String,
        default: ''
    },
  },
  data() {
    return {
      autoStart: true,
      isInstallUniview: false,
      isInitFlag: false,
      password: '',
      ip: '',
      port: '',
      username: '',
      token: '',
      protocol: 'HTTP'
    }
  },
  watch: {
    code: {
      async handler(nVal) {
        if (!nVal) {
          console.log("请提供宇视Code播放！");
          return;
        }
        this.autoStart && this.playLive();
      },
      immediate: true,
    },
  },
  created() {
    this.autoStart = this.config.autoStart != undefined ? this.config.autoStart : true;
  },
  async mounted() {},
  methods: {
    init() {
      if (this.isInitFlag) {
        console.warn("重复初始化！")
        return;
      }
      this.isInitFlag = true;
      // 如果本地配置存在则使用本地配置
      if (this.config && this.config.ip && this.config.port) {
        this.ip = this.config.ip
        this.port = this.config.port
        this.password = this.config.password
        this.username = this.config.username
        this.loadImossdk();
        return;
      }
      // 使用远程配置
      if (!this.code) {
        return
      }
      const url = this.proxyHost + URLS.getPluginConfigUrl;
      const params = {
        code: this.code,
      };
      axios.get(url, {params}).then((res) => {
        if (res.data.status === 200 && res.data.code === 200) {
          this.ip = res.data.result.host
          this.port = res.data.result.streamPort
          this.password = res.data.result.password
          this.username = res.data.result.username
          this.protocol = res.data.result.protocol;
          this.loadImossdk();
        }
      })
    },
    loadImossdk() {
      const prefix = this.protocol === "HTTP" ? "http://" : 'https://'
      const url = `${prefix}${this.ip}:${this.port}/static/imosSdk.min.js`

      loadScript(url, async () => {
        let res = await imosSdk.checkOutWebPlayer().catch(e=>{
          return null
        });
        if (res) {
          this.isInstallUniview = res.ErrCode === 0 ? true : false
        }

        if (this.isInstallUniview) {
          this.login();
        }
      })
    },
    login() {
      const url = `http://${this.ip}:${this.port}/VIID/login/v2`

      axios.post(url).then(res=>{
        let accessCode = res.data.AccessCode;
        let passwordMd5 = hex_md5(this.password);
        let base64username = window.btoa(this.username)
        let loginSignature = hex_md5(base64username + accessCode + passwordMd5)
        let params = {
          UserName: this.username,
          AccessCode: accessCode,
          LoginSignature: loginSignature
        }
        axios.post(url, params).then(res=>{
          if (!res.data.ErrCode) {
            this.token = res.data.AccessToken;
            localStorage.setItem(VIDEO_PREVIEW_KEYS.univiewToken, res.data.AccessToken)
            imosSdk.init(
              this.ip,
              this.token,
              9,
              "/app/imosSdk.html"
            ).then((res) => {
              this.initVideo();
            })
          } else {
            this.token = localStorage.getItem(VIDEO_PREVIEW_KEYS.univiewToken);
            if (this.token) {
              imosSdk.init(
                this.ip,
                this.token,
                9,
                "/app/imosSdk.html"
              ).then((res) => {
                this.initVideo();
              })
            }
            console.error(res)
          }
        })
      })
    },
    initVideo() {
      this.iframeObj = imosSdk.createPanelWindow();
      // 如果窗格创建已经到达上限
      if (this.iframeObj === null) {
          return;
      }
      const univiewVideoDom = document.getElementById(`uniview${this.code}`)
      univiewVideoDom.appendChild(this.iframeObj);
      this.autoStart && this.playLive(this.iframeObj.id);
    },
    playLive(iframeId) {
      if (!this.token) {
          console.warn("请先登录");
          return;
      }
      // 兼容新版Code
      let resultCode = this.interceptCode(this.code);
      imosSdk.playLive(
          iframeId,
          resultCode,
          resultCode,
          function (e) {
              console.log(e);
          }, 1
      );
    },
    // 兼容性Code修改 针对Code格式 V1_hk_panjinliaodongwanxin_3_509005815b374688a6c1bfdd01103942
    interceptCode(code) {
      let resultCode = code;
      if (resultCode.indexOf("uniview_") > -1) {
        const splitArray = resultCode.split("_");
        if (splitArray.length > 0) {
          resultCode = splitArray[splitArray.length - 1];          
        }
      }
      return resultCode;
    },
    previewBack(startTime, endTime, code, location) {
      if (!this.iframeObj || !this.iframeObj.id) {
        console.warn("初始化错误");
        return;
      }
      // 兼容新版Code
      let resultCode = this.interceptCode(code);
      imosSdk.playRecord(
          this.iframeObj.id,
          resultCode,
          resultCode,
          startTime,
          endTime,
          function (e) {
              console.log(e);
          }
      );
    },
    openLocalPlayer() {
      var $iframe = document.createElement('iframe');
      $iframe.style.display = 'none';
      $iframe.src = 'imos://startXPWebPlayer';
      $iframe.onload = function() {
          var timer = setTimeout(function(){
              clearTimeout(timer);
              document.body.removeChild($iframe);
          }, 5000);
      }
      document.body.appendChild($iframe);
    },
    downloadLocalPlayer() {
      if (!this.code) {
        return;
      }
      // 使用远程配置
      const url = this.proxyHost + URLS.getPluginConfigUrl;
      const params = {
        code: this.code,
      };
      axios.get(url, {params}).then((res) => {
        if (res.data.code === 200 && res.data.result.host) {
          const prefix = res.data.result.protocol === "HTTP" ? "http://" : 'https://'
          var aobj = document.createElement('a');
          aobj.download = '监控视频播放器.msi';
          aobj.target = '__blank';
          aobj.href = prefix + res.data.result.host + ":" + res.data.result.streamPort
 + '/ActiveX/WEBPlayer.msi';
          document.body.appendChild(aobj);
          aobj.click();
          document.body.removeChild(aobj);
        }
      })
    }
  }
}
</script>

<style lang="scss">
.video-preview-uniview {
  width: 100%;
  height: 100%;
  background: black;
  .imosSdk-video {
    width: 100%!important;
    height: 100%!important;
  }
  &-warp {
    width: 100%;
    height: 100%;
  }
  .video-preview-uniview-video {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    align-items: center;
  }
  .uninstall {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    width: 100%;
    height: 100%;
    line-height: 30px;
    .info {
      text-align: center;
      a {color: #3c9af3};
    }
  }
}
</style>